<template>
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
  >
    <path d="M6 0C7.65685 0 9 1.34315 9 3V4H10C11.1046 4 12 4.89543 12 6V13C12 14.1046 11.1046 15 10 15H2C0.89543 15 0 14.1046 0 13V6C0 4.89543 0.89543 4 2 4H3V3C3 1.34315 4.34315 0 6 0ZM10 5H2C1.44772 5 1 5.44772 1 6V13C1 13.5523 1.44772 14 2 14H10C10.5523 14 11 13.5523 11 13V6C11 5.44772 10.5523 5 10 5ZM6 8.5C6.55228 8.5 7 8.94772 7 9.5C7 10.0523 6.55228 10.5 6 10.5C5.44772 10.5 5 10.0523 5 9.5C5 8.94772 5.44772 8.5 6 8.5ZM6 1C4.89543 1 4 1.89543 4 3V4H8V3C8 1.89543 7.10457 1 6 1Z" />
  </svg>
</template>
